import { RequestMessage } from '../Messaging/RequestMessage';

export const checkNetworkMessageTag = 'CheckNetworkMessage';

/**
 * A Message to check whether the device is online.
 */
export class CheckNetworkMessage extends RequestMessage {
  readonly tag: string = checkNetworkMessageTag;
}